// extracted by mini-css-extract-plugin
export default {"main":"auth_main__Go1CB","logo":"auth_logo__ix3Aw","divider":"auth_divider__RO-E6","form":"auth_form__9-2iD","item":"auth_item__MFxdB","button":"auth_button__BJOOa"};